function oneTrustbtn() { 
const privacyDiv = document.getElementById('onetrust-pc-sdk');
if(privacyDiv){privacyDiv.classList.remove('ot-slide-out-left','ot-fade-in');
  privacyDiv.style='display:block !important;'};
  }

  //Klaviyo onclick code
   (function () {
    function extractFormId(href) {
      if (!href) return null;

      const hashPos = href.indexOf("#");
      if (hashPos === -1) return null;

      const hash = href.slice(hashPos + 1); // remove '#'
      const prefix = "klaviyo-open-form-";
      if (!hash.startsWith(prefix)) return null;

      // allow alphanumeric IDs like Rjvt6j
      return hash.slice(prefix.length).trim();
    }

    function openKlaviyoForm(formId) {
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", formId]);
    }

    // Click on link (your linked banner image)
    document.addEventListener("click", function (e) {
      if (e.defaultPrevented) return;
      const a = e.target.closest && e.target.closest("a[href*='#klaviyo-open-form-']");
      if (!a) return;

      const formId = extractFormId(a.getAttribute("href"));
      if (!formId) return;

      e.preventDefault();
      openKlaviyoForm(formId);
    });

    // Optional: if someone lands on a URL with that hash (email/ads), open immediately
    if (location.hash && location.hash.indexOf("#klaviyo-open-form-") === 0) {
      const formId = extractFormId(location.href);
      openKlaviyoForm(formId);

      // Clean up hash so refresh/back doesn't keep reopening
      history.replaceState(null, document.title, location.pathname + location.search);
    }
  })();
document.addEventListener('DOMContentLoaded', function() {
  /*Open Faq item handler B2C-7063*/
  (function(){
  let sp = new URLSearchParams(window.location.search);
  let fqmap = {
    "return":4
  }
  let faqItemIndex = sp?.get('fi') || null;
  if(fqmap[faqItemIndex]){
    faqItemIndex = fqmap[faqItemIndex];
  }
  const triggerFaqItemFunction = ()=>{
    let faqSection = document.getElementById('faq-contact');
    if(faqSection){
      faqSection.scrollIntoView();
      let faqItem = document.querySelector('.faq-item-'+faqItemIndex);
      if(faqItem){
        faqItem.children[0]?.classList.add('active')
      }
    }else{
      setTimeout(triggerFaqItemFunction,1000);
    }
  }
  if(faqItemIndex){
    triggerFaqItemFunction();
  }
  })();
  /*Open Faq item handler End*/
  /*YotpoWidget Observer to render after filter B2C-7097*/
  (function (){
  const productGrid = document.querySelector('.product-grid');
  if (productGrid) {
  const observerGrid = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        if(!!!window.filterTimeout){
          observerGrid.disconnect();
          window.filterTimeout = setTimeout(()=>{
            observerGrid.observe(productGrid, {
              childList: true,   // watch for added/removed nodes
              subtree: false      // include deeper descendants
            });
            if(yotpoWidgetsContainer){
              yotpoWidgetsContainer.initWidgets();
            }
            window.filterTimeout =  null;
          },1000);
          break;
        }
      }
    }
  });
  observerGrid.observe(productGrid, {
    childList: true,   // watch for added/removed nodes
    subtree: false      // include deeper descendants
  });
}
  })();
  /*YotpoWidget Observer End*/
  /*Filter blocked fix B2C-7096*/
  (function(){
  const filterDrawer = document.querySelector('.facets--drawer');
  if (filterDrawer){
  const filterDrawerObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        console.log('mutation',filterDrawer);
        if(filterDrawer.open){
          filterDrawer.inert = false;
          filterDrawer.style.opacity = '1';
          filterDrawer.style.pointerEvents = '';
        }
      }
    }
  });
  filterDrawerObserver.observe(filterDrawer, {
    attributes: true,     
    attributeFilter: ['open'],
  });
}
  })();
  /*Filter blocked fix end*/
});